import watch from 'redux-watch';

/* @ngInject */
export function AdministrationAccountsSiteLocationRscDetailsController($ngRedux, $uiRouterGlobals, AdministrationActions, Notifier) {
    var ctrl = this;
    var unsubscribe = angular.noop;
    var onRsc = angular.noop;

    ctrl.$onInit = function() {
        ctrl.identifier = 'administrationAccountsSiteLocationRsc';
        ctrl.checkboxFlex = 25;

        unsubscribe = $ngRedux.connect(mapStateToThis, AdministrationActions)(ctrl);
        ctrl.rscDetails = !_.isNull(ctrl.rsc.uuid);

        if (_.isUndefined(ctrl.stateParams.rsc))
            ctrl.getRscCandidates(ctrl.identifier, ctrl.stateParams.slo);

        var watchRsc = watch($ngRedux.getState, 'administration.administrationAccountsSiteLocationRsc.data.uuid');
        onRsc = $ngRedux.subscribe(watchRsc(function(uuid) {
            ctrl.rscDetails = !_.isNull(uuid);
        }));
    };

    ctrl.onRscDetails = function() {
        ctrl.siteLocationRscForm.$setPristine();
        ctrl.siteLocationRscForm.$setUntouched();
        ctrl.checkboxFlex = ctrl.rscDetails ? 50 : 25;
    };

    ctrl.manageRsc = function() {
        if (ctrl.siteLocationRscForm.$valid) {
            if (ctrl.rsc.uuid) {
                ctrl.updateRscDetails('administrationAccountsSiteLocationRsc', ctrl.rsc, 'administrationAccountsSiteLocationRscGrid');
            }
            else {
                if (ctrl.rscDetails)
                    ctrl.createRscDetails(ctrl.rsc, $uiRouterGlobals.params.slo, false, 'administrationAccountsSiteLocationRsc', 'administrationAccountsSiteLocationRscGrid');
                else
                    ctrl.assignRsc(ctrl.rscCandidate, $uiRouterGlobals.params.slo, 'administrationAccountsSiteLocationRsc', 'administrationAccountsSiteLocationRscGrid');
            }
        }
        else Notifier.error('Please fill in the form fields');
    };

    ctrl.$onDestroy = function() {
        unsubscribe();
        onRsc();
    };

    function mapStateToThis(state) {
        return {
            rsc: state.administration.administrationAccountsSiteLocationRsc.data,
            rscCandidate: state.administration.administrationAccountsSiteLocationRsc.candidate,
            stateParams: state.administration['app.administration.accounts.siteLocations'].stateParams,
            loading: _.find(state.administration['app.administration.accounts.siteLocations'].tabs, ['state', 'app.administration.accounts.siteLocations.rscDetails']).loading,
            title: [
                state.administration.administrationAccountsHeadOffice.name,
                state.administration.administrationAccountsSiteLocation.data.name,
                state.administration.administrationAccountsSiteLocationRsc.title
            ].filter(function(item) {
                return _.isString(item);
            }).join(' » ')
        };
    }
}
